export default "__VITE_ASSET__CaO0NEoH__"